export const errorMiddleware = (store: any) => (next: any) => (action: any) => {

    try {
        return next(action);
    }
    catch (err) {
        console.error(err);
    }
    
}